import request from '@/utils/request'

export function login(data) {
  return request({
    url: '/api/user/login/',
    method: 'post',
    data
  })
}

export function getInfo(data) {
  return request({
    url: '/api/user/info/',
    method: 'get',
    params: data
  })
}

export function logout() {
  return request({
    url: '/api/user/logout/',
    method: 'get'
  })
}


// orgInfo
export function getOrgInfo(data) {
  return request({
    url: '/api/org/',
    method: 'get',
    data
  })
}


// 获取多班级
export const getUserGrade = (params) => request.get('/api/user/get_user_grade', { params })


// WEBPACK FOOTER //
// ./src/api/user.js